import { useTranslation } from 'react-i18next';

import { SingleFilter } from '$/components/core/Collection/CollectionFilter/components/SingleFilter';
import { FilterDropdown } from '$/components/core/Collection/CollectionFilter/FilterDropdown';
import { LoadingDropdown } from '$/components/core/Editor/ColorSelectionSidebar/Filter/components/LoadingDropdown';
import { useCollectionStore } from '$/stores/useCollectionStore';

export const ProducerDropdown = () => {
  const { t } = useTranslation();

  const filter = useCollectionStore.useFilter();
  const getActiveInCategory = useCollectionStore.useGetActiveInCategory();

  const producerFilter = filter?.general.find(
    (item) => item.searchName === 'producer',
  );

  const activeProducer = producerFilter
    ? getActiveInCategory(producerFilter?.searchName)
    : [];

  const title =
    activeProducer.length > 0
      ? activeProducer[0].displayName
      : t('inspirationEditor.filter.producerDefault');

  return (
    <FilterDropdown
      title={title}
      loadingComponent={<LoadingDropdown title={title} />}
      bg='bodyBackground'
      border='1px solid'
      borderColor='border'
      textAlign='start'
      h='8'
      w='full'
      borderRadius='4'
      px='3'
      fontSize='sm'
    >
      {(onMenuClose) => (
        <SingleFilter
          onMenuClose={onMenuClose}
          options={producerFilter?.items ?? []}
          itemWidth='204px'
        />
      )}
    </FilterDropdown>
  );
};
